import { Logger } from 'aws-amplify';
const LOG = new Logger("WebRendezVous", "ERROR");

export default LOG;